import hljs from 'highlight.js';
import { setupSpoilerReveal } from './spoiler_reveal';
window.up.compiler('.js-post', (element) => {
    hljs.highlightAll();
    setupSpoilerReveal(element);
});
